// extracted by mini-css-extract-plugin
export default {"MergeQueueSectionText":"MergeQueueSection-module__MergeQueueSectionText--Vgwij"};